import { Reveal, Overline } from "@/components/Reveal";

const SCOOTER_IMG =
  "https://images.unsplash.com/photo-1768121496415-397a0a5daf8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxkZWxpdmVyeSUyMHBlcnNvbiUyMG1vZGVybiUyMHVyYmFufGVufDB8fHx8MTc4NjgzNDY2MHww&ixlib=rb-4.1.0&q=85";
const BRUSH_IMG =
  "https://images.unsplash.com/photo-1636262899511-dc5865c774dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxjbGVhbmluZyUyMHNob2VzJTIwYnJ1c2h8ZW58MHx8fHwxNzg2ODM0NjYwfDA&ixlib=rb-4.1.0&q=85";

const Chapter = ({ n, title, text, img, span, delay }) => (
  <Reveal delay={delay} className={`${span} group relative overflow-hidden border border-white/5 bg-carbon`}>
    {img && (
      <div className="relative h-56 overflow-hidden sm:h-64">
        <img
          src={img}
          alt={title}
          className="h-full w-full object-cover opacity-70 transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-carbon to-transparent" />
      </div>
    )}
    <div className="p-8 sm:p-10">
      <p className="font-mono text-xs tracking-[0.3em] text-aqua">{n}</p>
      <h3 className="mt-4 font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">
        {title}
      </h3>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-400">{text}</p>
    </div>
  </Reveal>
);

export default function Manifesto() {
  return (
    <section id="process" data-testid="process-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-12 lg:py-40">
      <Reveal>
        <Overline data-testid="process-overline">The process — four moves</Overline>
        <h2 className="mt-6 max-w-2xl font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tighter text-white sm:text-5xl lg:text-6xl">
          From doorstep<br />
          <span className="text-outline-aqua">to deadstock.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-8 md:grid-cols-12 lg:gap-12">
        <Chapter
          n="01"
          title="You book"
          text="Pick your service, choose doorstep collection or a local drop-off point, and grab a time slot that suits you. Sixty seconds, done."
          span="md:col-span-5"
          delay={0}
        />
        <Chapter
          n="02"
          title="We collect"
          text="Our couriers pick up from your door, bagged and tagged with a unique reference. Track every move from your account."
          img={SCOOTER_IMG}
          span="md:col-span-7"
          delay={0.1}
        />
        <Chapter
          n="03"
          title="We clean"
          text="Every pair is hand-cleaned by specialists — no machines, no shortcuts. Uppers, midsoles, laces, insoles. The lot."
          img={BRUSH_IMG}
          span="md:col-span-7"
          delay={0}
        />
        <Chapter
          n="04"
          title="We revive & return"
          text="Conditioned, protected and boxed. Delivered back to your door within 48 hours, looking like release day all over again."
          span="md:col-span-5"
          delay={0.1}
        />
      </div>
    </section>
  );
}
